import SuperAdminHome from '@/layouts/SuperAdminHome.vue'

const type = 'admin'

export const adminRoute = {
  path: '/admin',
  name: 'admin',
  component: SuperAdminHome,
  meta: {
    resource: [{ admin: 'all' }],
    type,
  },
  children: [
    {
      path: 'dashboard',
      name: `${type}/dashboard`,
      component: () => import(/* webpackChunkName: "SuperAdminDashboard" */ '../../views/SuperAdminDashboard.vue'),
    },
    {
      path: 'list-of-advisors/:advisorsParam?',
      name: `${type}/list-of-advisors`,
      component: () => import(/* webpackChunkName: "ListOfAdvisors" */ '../../views/ListOfAdvisors.vue'),
      children: [
        {
          path: 'all/:p?',
          name: `${type}/all-advisors`,
          component: () =>
            import(
              /* webpackChunkName: "ListAdvisorsAll" */ '../../components/SuperAdmin/ListOfAdvisors/ListAdvisorsAll.vue'
            ),
        },
      ],
    },
    {
      path: 'leads',
      name: `${type}/leads`,
      component: () => import(/* webpackChunkName: "Leads" */ '../../views/Leads.vue'),
      children: [
        {
          path: 'all-leads/:p?',
          name: `${type}/all-leads`,
          component: () => import(/* webpackChunkName: "ListLeads" */ '../../components/ListLeads/ListAllLeads.vue'),
        },
        {
          path: 'active-leads/:p?',
          name: `${type}/active-leads`,
          component: () =>
            import(/* webpackChunkName: "ListActiveLeads" */ '../../components/ListLeads/ListActiveLeads.vue'),
        },
        {
          path: 'deactivated-leads/:p?',
          name: `${type}/deactivated-leads`,
          component: () =>
            import(
              /* webpackChunkName: "ListDeactivatedLeads" */ '../../components/ListLeads/ListDeactivatedLeads.vue'
            ),
        },
      ],
    },
    {
      path: 'list-of-households/:AdminHouseholdsParam?',
      name: `${type}/list-of-households`,
      component: () => import(/* webpackChunkName: "ListOfHouseholds" */ '../../views/ListOfHouseholds.vue'),
      children: [
        {
          path: 'all/:p?',
          name: `${type}/all`,
          component: () =>
            import(/* webpackChunkName: "ListOfHouseholds" */ '../../components/ListOfHouseholds/ListAll.vue'),
        },
        {
          path: 'opportunities/:p?',
          name: `${type}/opportunities`,
          component: () =>
            import(
              /* webpackChunkName: "ListOfHouseholds" */ '../../components/ListOfHouseholds/ListOpportunities.vue'
            ),
        },
        {
          path: 'prospects/:p?',
          name: `${type}/prospects`,
          component: () =>
            import(/* webpackChunkName: "ListOfHouseholds" */ '../../components/ListOfHouseholds/ListProspects.vue'),
        },
        {
          path: 'clients/:p?',
          name: `${type}/clients`,
          component: () =>
            import(/* webpackChunkName: "ListOfHouseholds" */ '../../components/ListOfHouseholds/ListClients.vue'),
        },
        {
          path: 'business/:p?',
          name: `${type}/business`,
          component: () =>
            import(/* webpackChunkName: "ListOfHouseholds" */ '../../components/ListOfHouseholds/ListBusiness.vue'),
        },
        {
          path: 'professional-relationship/:p?',
          name: `${type}/professional-relationship`,
          component: () =>
            import(
              /* webpackChunkName: "ListOfHouseholds" */ '../../components/ListOfHouseholds/ListProfessionalRelationship.vue'
            ),
        },
      ],
    },
    {
      path: 'schwab/:p?',
      name: `schwab`,
      component: () =>
        import(/* webpackChunkName: "ListContent" */ '../../components/SchwabReport/SchwabDashboard.vue'),
    },
    {
      path: 'profile/:id?/:p?',
      name: `${type}/profile`,
      component: () =>
        import(/* webpackChunkName: "Transactions" */ '../../components/SchwabReport/Account/Profile.vue'),
    },
    {
      path: 'annuity-index',
      name: 'annuity-index',
      component: () =>
        import(/* webpackChunkName: "AnnuityIndex" */ '../../components/AnnuityIndex/AnnuityIndexList.vue'),
    },
    {
      path: 'annuity-index-details/:id?',
      name: 'annuity-index-details',
      component: () =>
        import(/* webpackChunkName: "AnnuityIndexItem" */ '../../components/AnnuityIndex/AnnuityIndexDetails.vue'),
    },

    {
      path: 'activity',
      name: `${type}/activity`,
      component: () => import(/* webpackChunkName: "Activity" */ '../../views/Activity.vue'),
    },
    {
      path: 'pipeline/:p?',
      name: `${type}/pipeline`,
      component: () => import(/* webpackChunkName: "PipeLine" */ '../../views/PipeLine.vue'),
    },
    {
      path: 'member/:id',
      name: `${type}/member`,
      component: () => import(/* webpackChunkName: "MemberDetails" */ '../../views/MemberDetails.vue'),
      children: [
        {
          path: 'member-details',
          name: `${type}/member-details`,
          component: () =>
            import(/* webpackChunkName: "MemberDetails" */ '../../components/MemberDetails/MemberDetails.vue'),
        },
        {
          path: 'annuity-index/:annuityId',
          name: `${type}/annuity-index`,
          component: () =>
            import(/* webpackChunkName: "AnnuityIndex" */ '../../components/AnnuityIndex/AnnuityIndexList.vue'),
        },

        {
          path: 'annuity-index-details/:annuityId?',
          name: `${type}/annuity-index-details`,
          component: () =>
            import(/* webpackChunkName: "AnnuityIndexItem" */ '../../components/AnnuityIndex/AnnuityIndexDetails.vue'),
        },
        {
          path: 'tasks',
          name: `${type}/tasks`,
          component: () =>
            import(/* webpackChunkName: "MemberDetails" */ '../../components/Tasks/MemberAllTaskList.vue'),
        },
        {
          path: 'meeting-notes/:p?',
          name: `${type}/meeting-notes`,
          component: () =>
            import(/* webpackChunkName: "AllMeetingNotes" */ '../../components/MeetingNotes/AllMeetingNotes.vue'),
        },
        {
          path: 'meeting-note-new',
          name: `${type}/meeting-note-new`,
          component: () =>
            import(
              /* webpackChunkName: "MeetingNoteForm" */
              '@/components/MeetingNotes/MeetingNoteFormPage.vue'
            ),
        },
        {
          path: 'meeting-note-edit/:noteId',
          name: `${type}/meeting-note-edit`,
          component: () =>
            import(
              /* webpackChunkName: "MeetingNoteForm" */
              '@/components/MeetingNotes/MeetingNoteFormPage.vue'
            ),
          props: true,
        },
        {
          path: 'meeting-note-details/:noteId',
          name: `${type}/meeting-note-details`,
          component: () =>
            import(
              /* webpackChunkName: "MeetingNoteDetails" */
              '@/components/MeetingNotes/MeetingNoteDetailPage.vue'
            ),
          props: true,
        },
        {
          path: 'referral/new',
          name: `${type}/referral-new`,
          component: () => import(/* webpackChunkName: "ReferralForm" */ '../../components/Referral/ReferralForm.vue'),
        },
        {
          path: 'referral/edit/:referralId',
          name: `${type}/referral-edit`,
          component: () => import(/* webpackChunkName: "ReferralForm" */ '../../components/Referral/ReferralForm.vue'),
        },
        {
          path: 'gifts/new',
          name: `${type}/gift-new`,
          component: () => import('../../components/Gifts/GiftFormPage.vue'),
        },
        {
          path: 'gifts/:giftId/edit',
          name: `${type}/gift-edit`,
          component: () => import('../../components/Gifts/GiftFormPage.vue'),
        },
        {
          path: 'gifts/:giftId',
          name: `${type}/gift-details`,
          component: () => import('../../components/Gifts/GiftDetailsPage.vue'),
        },
        {
          path: 'contacts',
          name: `${type}/member-contacts`,
          component: () =>
            import(
              /* webpackChunkName: "MemberContacts" */ '../../components/OpportunityContact/OpportunityContact.vue'
            ),
        },
        {
          path: 'contacts/create',
          name: `${type}/member-contact-create`,
          component: () =>
            import(
              /* webpackChunkName: "MemberContactCreate" */ '../../components/MemberDetails/MemberContact/MemberContactCreate.vue'
            ),
        },
        {
          path: 'contacts/:contactId/edit',
          name: `${type}/member-contact-edit`,
          component: () =>
            import(
              /* webpackChunkName: "MemberContactEdit" */ '../../components/MemberDetails/MemberContact/MemberContactEdit.vue'
            ),
        },
        {
          path: 'add-client-note',
          name: `${type}/add-client-note`,
          component: () =>
            import(/* webpackChunkName: "AddClientNote" */ '../../components/ClientNotes/AddClientNote.vue'),
        },
        {
          path: 'edit-client-note/:noteId',
          name: `${type}/edit-client-note`,
          component: () =>
            import(/* webpackChunkName: "EditClientNote" */ '../../components/ClientNotes/EditClientNote.vue'),
        },
      ],
    },
    {
      path: 'edit-member-basic-information/:id',
      name: `${type}/edit-member-basic-information`,
      component: () =>
        import(
          /* webpackChunkName: "MemberDetails" */ '../../components/MemberBasicInformation/EditMemberBasicInformation.vue'
        ),
    },
    {
      path: 'opportunity/new/:id',
      name: `${type}/opportunity-new`,
      component: () =>
        import(
          /* webpackChunkName: "OpportunityForm" */ '../../components/MemberDetails/Opportunity/OpportunityForm.vue'
        ),
    },
    {
      path: 'opportunity/edit/:id/:opportunityId',
      name: `${type}/opportunity-edit`,
      component: () =>
        import(
          /* webpackChunkName: "OpportunityForm" */ '../../components/MemberDetails/Opportunity/OpportunityForm.vue'
        ),
    },
    {
      path: 'annuity-details/:contractId',
      name: `${type}/annuity-details`,
      component: () => import(/* webpackChunkName: "AnnuityForm" */ '../../components/Annuity/AnnuityForm.vue'),
    },
    {
      path: 'blueprint-report/:id',
      name: `${type}/blueprint-report`,
      component: () => import(/* webpackChunkName: "BlueprintReport" */ '../../components/Report/BlueprintReport.vue'),
    },
    {
      path: 'client-report/:id',
      name: `${type}/clientreport`,
      component: () => import(/* webpackChunkName: "ClientReport" */ '../../views/ClientReport.vue'),
      children: [
        {
          path: 'client-reports-list',
          name: `${type}/client-reports-list`,
          component: () =>
            import(/* webpackChunkName: "ClientReport" */ '../../components/ClientReport/ClientReportList.vue'),
        },
        {
          path: 'contract-info/:contract_id?',
          name: `${type}/contract-info`,
          component: () =>
            import(/* webpackChunkName: "ClientReport" */ '../../components/ClientReport/ContractDetails.vue'),
        },
      ],
    },
    {
      path: 'export-report/:id',
      name: `${type}/export-report`,
      component: () =>
        import(
          /* webpackChunkName: "ExportReport" */ '../../components/Documents/ClientReport/ExportClientReports.vue'
        ),
      children: [
        {
          path: 'all',
          name: `${type}/all-report`,
          component: () =>
            import(
              /* webpackChunkName: "ExportReport" */ '../../components/Documents/ClientReport/ClientReportAll.vue'
            ),
        },
        {
          path: 'pdf',
          name: `${type}/pdf-report`,
          component: () =>
            import(
              /* webpackChunkName: "ExportReport" */ '../../components/Documents/ClientReport/ClientReportPdf.vue'
            ),
        },
        {
          path: 'excel',
          name: `${type}/excel-report`,
          component: () =>
            import(
              /* webpackChunkName: "ExportReport" */ '../../components/Documents/ClientReport/ClientReportExcel.vue'
            ),
        },
      ],
    },
    {
      path: 'past-stress-test/:id',
      name: `${type}/past-stress-test`,
      component: () =>
        import(
          /* webpackChunkName: "PastStressTestResults" */ '../../components/MemberDetails/PastStressTestResults.vue'
        ),
    },
    {
      path: 'opportunity-contact/:id',
      name: `${type}/opportunity-contact`,
      component: () =>
        import(
          /* webpackChunkName: "OpportunityContact" */ '../../components/OpportunityContact/OpportunityContact.vue'
        ),
    },
    {
      path: 'basic-information/:id',
      name: `${type}/basic-information`,
      component: () =>
        import(
          /* webpackChunkName: "MemberDetails" */ '../../components/MemberBasicInformation/MemberBasicInformation.vue'
        ),
    },
    {
      path: 'asset-accounts/:id',
      name: `${type}/asset-accounts`,
      component: () =>
        import(/* webpackChunkName: "AssetAccounts" */ '../../components/AssetAccounts/AssetAccounts.vue'),
    },

    {
      path: 'assets-consolidations/:id',
      name: `${type}/assets-consolidations`,
      component: () =>
        import(
          /* webpackChunkName: "AssetsConsolidations" */ '../../components/AssetsConsolidations/AssetsConsolidations.vue'
        ),
    },
    {
      path: 'revenue-dashboard',
      name: `${type}/revenue-dashboard`,
      component: () =>
        import(/* webpackChunkName: "RevenueDashboard" */ '../../components/RevenueDashboard/RevenueDashboard.vue'),
    },
    {
      path: 'dashboard-link/add',
      name: `${type}/dashboard-link-add`,
      component: () => import(/* webpackChunkName: "AddLink" */ '../../components/RevenueDashboard/AddLink.vue'),
    },
    {
      path: 'dashboard-link/:id/edit',
      name: `${type}/dashboard-link-edit`,
      component: () => import(/* webpackChunkName: "AddLink" */ '../../components/RevenueDashboard/AddLink.vue'),
    },
    {
      path: 'analytics-dashboard',
      name: `${type}/analytics-dashboard`,
      component: () =>
        import(/* webpackChunkName: "ListOfHouseholds" */ '../../components/RevenueDashboard/AnalyticsDashboard.vue'),
    },
    {
      path: 'meeting-note-print/:id',
      name: `${type}/meeting-note-print`,
      component: () =>
        import(
          /* webpackChunkName: "MeetingNotePrintPreview" */ '../../components/MeetingNotes/MeetingNotePrintPreview.vue'
        ),
    },
    {
      path: 'task/new',
      name: `${type}/task-new`,
      component: () => import(/* webpackChunkName: "TaskForm" */ '../../views/TaskForm.vue'),
    },
    {
      path: 'task/:taskId',
      name: `${type}/task-edit`,
      component: () => import(/* webpackChunkName: "TaskForm" */ '../../views/TaskForm.vue'),
    },
    {
      path: 'contacts',
      name: `${type}/contacts`,
      component: () => import('../../components/GlobalContact/ContactsList.vue'),
    },
    {
      path: 'contacts/create',
      name: `${type}/contacts-create`,
      component: () => import('../../components/GlobalContact/ContactsCreate.vue'),
    },
    {
      path: 'contacts/:id/edit',
      name: `${type}/contacts-edit`,
      component: () => import('../../components/GlobalContact/ContactsEdit.vue'),
    },
    {
      path: 'interaction/new',
      name: `${type}/interaction-new`,
      component: () => import(/* webpackChunkName: "InteractionForm" */ '../../views/InteractionForm.vue'),
    },
    {
      path: 'interaction/:interactionId',
      name: `${type}/interaction-edit`,
      component: () => import(/* webpackChunkName: "InteractionForm" */ '../../views/InteractionForm.vue'),
    },
  ],
}
